import { render, staticRenderFns } from "./preferences.vue?vue&type=template&id=481852eb&"
import script from "./preferences.vue?vue&type=script&lang=js&"
export * from "./preferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports